import React, { PropTypes, Component } from 'react';

class BetaInfo extends Component {
  render() {
    return (
      <div className="BetaInfo">
        <h4>Not what you expected?</h4>
        This service is still in Beta phase, if you are not seeing what you expected to see, please send me a short mail via the link in the footer with a link to this page and help me improve this service.
      </div>
    );
  }
}

export default BetaInfo;



/** WEBPACK FOOTER **
 ** ./src/components/BetaInfo/BetaInfo.js
 **/